import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/auth";
import { useNavigate } from "react-router-dom";

export default function ProtectedRoute({ component }) {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const authorizeUser = async () => {
    try {
      const response = await fetch("https://hotelbnb-backend.onrender.com/authorize", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        return;
      }
      return navigate("/login");

    } catch (error) {
      console.log(error);
      navigate("/login");
    } finally{
      setLoading(false);
    }

  };

  useEffect(() => {
    authorizeUser();
  }, []);

  if (loading)
    return (
      <div class="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div class="spinner-grow" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  if(!loading) return <>{component}</>;
}
